import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const TopicListWrapper = styled.div`
    display: grid;
    gap: 80px 48px;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    margin-top: 120px;

    a:hover {
        text-decoration: none;
    }
`;

const TopicHeader = styled.div`
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;
    justify-content: space-between;
    margin-bottom: 24px;
    padding-bottom: 12px;
`;
const TopicHeaderTitle = styled.h2`
    font-size: 2rem;
    letter-spacing: -0.015em;
    margin: 0;
    a {
        color: #15181a;
    }
`;
const TopicHeaderReadmore = styled.a`
    align-items: center;
    display: inline-flex;
    font-weight: 600;
    letter-spacing: -0.011em;
    color: #999999;
`;

const TopicContentCard = styled.article`
    max-width: 720px;
    margin-top: 16px;
`;
const TopicContentTitle = styled.a`
    color: #3c484e;
    text-decoration: none;
    font-size: 1.6rem;
    font-weight: 400;
    letter-spacing: -0.01em;
    line-height: 1.6;
    &:hover {
        text-decoration: none;
        opacity: 0.7;
    }
`;

const TopicList = ({ data }) => {
    return (
        <TopicListWrapper>
            {data.map((topic) => (
                <div key={topic.tag}>
                    <TopicHeader>
                        <TopicHeaderTitle>
                            <a href={topic.link}>{topic.tag}</a>
                        </TopicHeaderTitle>
                        <TopicHeaderReadmore href={topic.link}>
                            {"More→"}
                        </TopicHeaderReadmore>
                    </TopicHeader>
                    <div>
                        {topic.data.map(
                            (article, index) =>
                                index < 5 && (
                                    <TopicContentCard key={article.node.slug}>
                                        <TopicContentTitle
                                            href={`/${article.node.slug}/`}
                                        >
                                            {article.node.title}
                                        </TopicContentTitle>
                                    </TopicContentCard>
                                )
                        )}
                    </div>
                </div>
            ))}
        </TopicListWrapper>
    );
};

TopicList.propTypes = {
    data: PropTypes.array,
};

export default TopicList;
